export const UPDATE_SCENARIO_REPORT_VALUE = 'UPDATE_SCENARIO_REPORT_VALUE';
export const UPDATE_SCENARIO_REPORT_VALUE_SUCCESS = 'UPDATE_SCENARIO_REPORT_VALUE_SUCCESS';
export const UPDATE_SCENARIO_REPORT_VALUE_FAILURE = 'UPDATE_SCENARIO_REPORT_VALUE_FAILURE';
export const RESET_SCENARIO_REPORT_VALUE = 'RESET_SCENARIO_REPORT_VALUE';
export const RESET_SCENARIO_REPORT_VALUE_SUCCESS = 'RESET_SCENARIO_REPORT_VALUE_SUCCESS';
export const RESET_SCENARIO_REPORT_VALUE_FAILURE = 'RESET_SCENARIO_REPORT_VALUE_FAILURE';
